import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

// Components
import OrderSearch from './OrderSearch'
import Order from './Order'

// State
import { setpageTitle } from '../../../store/actions/siteInfo'
import { addRoute } from '../../../store/actions/route'

class CustomerOrders extends Component {
    constructor(props){
        super(props)
        this.props.addRoute(this.props.match)

        this.props.setpageTitle('View Orders')
    }

    render() {
        return (
            <div>
                <h1>View Orders</h1>

                <Switch>
                    <Route path={'/customer/orders'} exact component={OrderSearch} />
                    <Route path={'/customer/orders/:id'} component={Order} />
                </Switch>
            </div>
        )
    }
}

export default connect(null, { addRoute, setpageTitle })(CustomerOrders)



// WEBPACK FOOTER //
// ./src/components/customer/orders/CustomerOrders.js